import { __assign } from '../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import Slider from '../../node_modules/react-slick/lib/index.js';
import { forwardRef } from 'react';

var Component = forwardRef(function (props, ref) { return (jsx(Slider, __assign({}, props, { dots: false, arrows: false, ref: ref }))); });
Component.displayName = 'CarouselSlider';
var CarouselSlider = Component;

export { CarouselSlider };
